<app-esqueleto-tableros [filterWidth]="500">
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="Periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)">
  </app-filters>  
  <div contenido class="zonaContenido">
    <div class="w3-row" style="background-color: white;">
      <div class="headers w3-titulo-contenidomenuSC w3-half">
        <span class="w3-margin-left-contenido">{{tituloTabla|translate}}</span>
        <span class="w3-margin-left-contenido">&bull;</span>
        <span class="w3-margin-left-filter w3-subtitulo">
          @for(per of subTitles; track $index){
            <span style="margin-left: 5px;">{{escrituraPer(per)}}</span>
          }
        </span>
      </div>
      <div class="w3-rest w3-right">
        <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menutabla1">
          more_vert
        </mat-icon>
        <mat-menu #menutabla1="matMenu">
          @if(cuentas){
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="cuentas = !cuentas; tituloTabla = 'financiero.catalogoCuentas.tituloTabla31'">
              <span>{{'financiero.catalogoCuentas.tituloTabla31'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportExcel()">
              <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.Exportar'|translate}}</span>
            </button>
          }@else{
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="cuentas = !cuentas; tituloTabla = 'financiero.catalogoCuentas.tituloTabla3'">
              <span>{{'financiero.catalogoCuentas.tituloTabla3'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportExcel2()">
              <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.Exportar'|translate}}</span>
            </button>
          }
        </mat-menu>
      </div>
      <div class="w3-row" style="width: 100%; height: 1vh;"></div>
    </div>
    <div class="w3-row containerAll w3-scroll">
      @if(cuentas){
        @if(dataOrdenado.length > 0){
          <table class="w3-table borderInf">
            <thead style="background-color: #A7A9AC;">
              <tr class="w3-table-titleBalance">
                <th class="w3-elemento-titulo-table stikyColum w3-border-right-balance marginsH">{{'financiero.catalogoCuentas.encabezado1Tabla1'|translate}}</th>
                <th class="w3-elemento-titulo-table stikyColum w3-border-right-balance marginsH">{{'financiero.catalogoCuentas.encabezado2Tabla1'|translate}}</th>
                @if(multiMoneda){<th class="w3-elemento-titulo-table stikyColum w3-border-right-balance marginsH"
                  style="max-width: 3vw; min-width: 3vw;">{{'financiero.catalogoCuentas.encabezado4Tabla1'|translate}}</th>}
                @for(eva of cadenaEvaluacion; track $index){
                  <th class="w3-elemento-titulo-table stikyColum w3-border-right-balance marginsH">{{escrituraPer(eva.evaluacion)}}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for(item of dataOrdenado; track item; let i = $index){
                @if(item.check){
                  <tr [ngClass]="{
                    'w3-table-trtdBalanceBlue w3-encabezado-balance w3-border-Nivel0Balance':item.id.length===0||item.id.length===2,
                    'w3-table-trtdBalance w3-cuerpo-balance':item.id.length>2
                  }">
                    <td class="borderAllLow" [ngClass]="fontRowBalance(item.id.length)">
                      {{item?.codigo ?? item.id}}
                    </td>
                    <td class="borderAllLow" [ngClass]="fontRowBalance(item.id.length)">
                      @if(searchSubNivelBalance(item, i)){
                        <mat-icon class="iconoMen w3-button" (click)="hideShowRowBalance(item, i)">
                          {{item.dbCheck?'expand_less':'expand_more'}}
                        </mat-icon>
                      }@else{
                        <mat-icon class="iconoMen w3-button" style="cursor: default;"></mat-icon>
                      }
                      <span [ngClass]="{
                        'w3-margin-lelf-1roB':item.nivel===1 || item.nivel === 1.5,
                        'w3-margin-lelf-2doB':item.nivel===2,
                        'w3-margin-lelf-3roB':item.nivel===3,
                        'w3-margin-lelf-4toB':item.nivel===4,
                        'w3-margin-lelf-5toB':item.nivel===5,
                        'w3-margin-lelf-6toB':item.nivel===6
                      }">{{item.descripcion}}</span>
                    </td>
                    @if(multiMoneda){
                      <td class="w3-center borderAllLow" [ngClass]="fontRowBalance(item.id.length)">
                        {{item.moneda}}
                      </td>
                    }
                    @for(dat of item.series; track dat; let j = $index){
                      <td class="alinRight borderAllLow marginsH" [ngClass]="fontRowBalance(item.id.length)">
                        {{dat.valor | formaterNumber:0:miles:decimal}}
                      </td>
                    }
                  </tr>
                }
              }
            </tbody>
          </table>  
        }@else {
          <app-skeleton-table [columnas]="3" [filas]="15"/>
        }
        
      }@else{
        <table class="w3-table borderInf">
          <thead style="background-color: #A7A9AC;">
            <tr class="w3-table-titleBalance">
              <th class="w3-elemento-titulo-table stikyColum w3-border-right-balance marginsH">{{'financiero.catalogoCuentas.encabezado1Tabla1'|translate}}</th>
              <th class="w3-elemento-titulo-table stikyColum w3-border-right-balance marginsH">{{'financiero.catalogoCuentas.encabezado2Tabla1'|translate}}</th>
              <!-- @if(multiMoneda){<th class="w3-elemento-titulo-table stikyColum w3-border-right-balance marginsH"
                style="max-width: 2vw;">{{'financiero.catalogoCuentas.encabezado4Tabla1'|translate}}</th>} -->
              @for(eva of cadenaEvaluacion; track $index){
                <th class="w3-elemento-titulo-table stikyColum w3-border-right-balance marginsH"><span style="margin-left: 5%;">{{escrituraPer(eva.evaluacion)}}</span></th>
              }
            </tr>
          </thead>
          <tbody>
            @for(item of dataOrdenado2; track item; let i = $index){
              @if(item.check){
                <tr [ngClass]="{
                  'w3-table-trtdBalanceBlue w3-encabezado-balance w3-border-Nivel0Balance':item.id.length===0||item.id.length===2,
                  'w3-table-trtdBalance w3-cuerpo-balance':item.id.length>2
                }">
                  <td class="borderAllLow" [ngClass]="fontRowBalance(item.id.length)">
                    {{item.id}}
                  </td>
                  <td class="borderAllLow" [ngClass]="fontRowBalance(item.id.length)">
                    @if(searchSubNivelBalance(item, i)){
                      <mat-icon class="iconoMen w3-button" (click)="hideShowRowBalance(item, i)">
                        {{item.dbCheck?'expand_less':'expand_more'}}
                      </mat-icon>
                    }@else{
                      <mat-icon class="iconoMen w3-button" style="cursor: default;"></mat-icon>
                    }
                    <span [ngClass]="{
                      'w3-margin-lelf-1roB':item.nivel===1,
                      'w3-margin-lelf-2doB':item.nivel===2,
                      'w3-margin-lelf-3roB':item.nivel===3,
                      'w3-margin-lelf-4toB':item.nivel===4,
                      'w3-margin-lelf-5toB':item.nivel===5,
                      'w3-margin-lelf-6toB':item.nivel===6
                    }">{{item.descripcion}}</span>
                  </td>
                  <!-- @if(multiMoneda){
                    <td class="w3-center borderAllLow" [ngClass]="fontRowBalance(item.id.length)">
                      {{item.moneda}}
                    </td>
                  } -->
                  @for(dat of item.series; track dat; let j = $index){
                    <td class="alinRight borderAllLow" [ngClass]="fontRowBalance(item.id.length)">
                      <span style="margin-right: 5%;">{{dat.valor | formaterNumber:0:miles:decimal}}</span>
                    </td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</app-esqueleto-tableros>